<template>
  <van-popup :value="visible" position="bottom" get-container="body" class="record-pop">
    <van-nav-bar title="库存明细" :border="false" left-arrow @click-left="$emit('update:visible', false)" />
    <wh-mobile-list
      v-if="visible"
      :extra-params="extraParams"
      data-src="/api/getAgriculturalRecordList"
    >
      <template #default="{list}">
        <table class="record-table">
          <tbody>
            <tr v-for="i in list" :key="i.id">
              <td>
                <div class="date-tag">
                  {{ i.date }}
                </div>
              </td>
              <td>
                <div class="type">
                  {{ i.changeType }}
                  <span :class="i.recordType|color" class="count">{{ i | count }}</span>
                </div>
              </td>
              <td>
                <div class="staff">
                  负责人:{{ i.operator }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </template>
    </wh-mobile-list>
    <div class="operate-box wh-flex-between">
      <van-button :disabled="!agrData.count" type="primary" round @click="handleClickManage('出库')">
        新增出库
      </van-button>
      <van-button round @click="handleClickManage('入库')">
        新增入库
      </van-button>
    </div>
    <agr-manage
      :visible.sync="popup.manage"
      :agr-data="agrData"
      :stock-type="stockType"
      @success="handleManageSuccess"
    />
  </van-popup>
</template>

<script>
import WhMobileList from '@/components/public/WhMobileList/WhMobileList'
import AgrManage from '@/views/agrStock/components/AgrManage'
export default {
  name: 'AgrRecord',
  components: { AgrManage, WhMobileList },
  filters: {
    color(val) {
      switch (val) {
        case '出库':
          return 'yellow'
        case '入库':
          return 'blue'
      }
    },
    count(val) {
      const count = `${val.changeCount}${val.unit}`
      switch (val.recordType) {
        case '出库':
          return '-' + count
        case '入库':
          return '+' + count
      }
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    agrData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      popup: {
        manage: false
      },
      stockType: ''
    }
  },
  computed: {
    extraParams() {
      return {
        recordType: 'all',
        agriculturalId: this.agrData.id
      }
    }
  },
  methods: {
    handleClickManage(type) {
      this.stockType = type
      this.popup.manage = true
    },
    handleManageSuccess() {
      this.$emit('update:visible', false)
      this.$emit('success')
    }
  }
}
</script>

<style lang="less" scoped>
.record-pop {
  height: 100%;
  background: #F6F5F5;
}
.yellow {
  color: #FEA501;
}
.blue {
  color: #3F8CFF;
}
.record-table {
  width: 100%;
  font-size: 12px;
  background: #fff;
  td {
    padding: 12px;
    vertical-align: middle;
  }
  tr {
    border-bottom: 1px solid #eee;
  }
  .date-tag {
    text-align: center;
    color: #fff;
    background: @primary-color;
    padding: 3px;
    border-radius: 2px;
  }
  .type {
    color: #323332;
  }
  .staff {
    color: #BBBBBB;
  }
}
.operate-box {
  position: absolute;
  bottom: 20px;
  left: 20px;
  right: 20px;
  .van-button {
    width: 156px;
    height: 40px;
    border-radius: 24px;
    &.van-button--primary {
      background-color: @primary-color;
      border-color: @primary-color;
    }
    &.van-button--default {
      color: @primary-color;
      border-color: #fff;
    }
  }
}
</style>
